export {useDisplayNames} from '../../../src/datepicker/useDisplayNames';
